import React from "react";

interface OwnProps {
    orientation?: ArrowIconOrientation;
    width?: number;
    height?: number;
    fill?: string;
}

export const ArrowIcon = (props: OwnProps) => {
    const { orientation, width = 20, height = 14, fill = "#646363" } = props;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                transform:
                    orientation === ArrowIconOrientation.Down
                        ? "rotate(180deg)"
                        : undefined,
            }}
        >
            <path d="M7 0L13.9282 7.5L0.0717969 7.5L7 0Z" fill={fill} />
        </svg>
    );
};

export enum ArrowIconOrientation {
    Up,
    Down,
}



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowIcon.tsx